<template>
  <div class="bb-vat">
    <div class="bb-vat-item">
      <span class="bb-vat-item__title">VAT</span>
      <input class="bb-vat-item__input" v-model="company.settings.vat" v-if="editOpen" v-autofocus>
      <span class="bb-vat-item__input" v-else>{{company.settings.vat}}</span>
      <i class="icon-percent bb-vat-percent__percent"></i>
    </div>
    <button class="bb-vat__btn-save bb-button" @click="editCompany()" v-if="editOpen">
      SAVE
    </button>
    <button class="bb-vat__btn-save bb-button" @click="editOpen = true" v-else>
      EDIT
    </button>
  </div>
</template>

<script>
import CompaniesApi from '@/api/Companies/api'
import {get} from 'lodash'

export default {
  name: 'VAT',
  data: function () {
    return {
      editOpen: false,
      company: {
        name: '',
        settings: {}
      }
    }
  },
  computed: {
    activeCompany: function () {
      return this.$store.getters.activeCompany
    }
  },
  methods: {
    getCompany () {
      if (!this.activeCompany) {
        return
      }
      CompaniesApi.getCompaniesById(this.activeCompany)
        .then((resp) => {
          const imageId = get(resp, 'data.image.id', '')
          this.company = resp.data
          if (imageId) this.company.image = imageId
          this.$emit('setVat', this.company.settings)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    editCompany () {
      CompaniesApi.editCompany({company: this.company}, this.activeCompany)
        .then((resp) => {
          this.editOpen = false
          const imageId = get(resp, 'data.image.id', '')
          this.company = resp.data
          if (imageId) this.company.image = imageId
          this.$emit('setVat', this.company.settings)
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  watch: {
    activeCompany: function () {
      this.getCompany()
    }
  },
  beforeMount () {
    this.getCompany()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-vat {
    @include global-font;
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    line-height: 17px;

    &-item {
      display: flex;
      align-items: center;
      margin-right: 25px;

      &__title {
        min-width: 55px;
      }

      &__input {
        font-family: $global-font;
        display: flex;
        align-items: center;
        margin-right: 6px;
        padding: 0 14px;
        width: 107px;
        height: 40px;
        border: none;
        border-radius: 6px;
        background-color: $color-white;
        font-size: 14px;
        line-height: 17px;
      }

      &__percent {
        font-size: 12px;
      }
    }

    &__btn-save {
      width: 73px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Services/VAT/VAT.vue